<template>
  <!-- banner -->
  <section v-if="bannerTopo != ''" class="hero-wrap hero-wrap-2"
    :style="{ backgroundImage: 'url(' + $imgURL + bannerTopo[0].insInstitucionalImagens[0].itgUrlImagem + ')' }">
    <div class="overlay"></div>
    <div class="container">
      <div class="row no-gutters slider-text align-items-end">
        <div class="col-md-9 pb-5">
          <h1 class="mb-0 bread">{{ bannerTopo[0].itiNome }}</h1>
        </div>
      </div>
    </div>
  </section>
  <!-- END banner -->

  <!-- soluções -->
  <section v-if="bannerTopo != ''" class="ftco-section ftco-services espaco100"
    style="background-image: url('/images/use_your_illusion_solucoes.png'); background-repeat: repeat;">
    <div class="container">
      <div class="row">
        <div class="col-md-12 d-flex align-self-stretch">
          <div class="pb-4 heading-section heading-section-white">
            <h2 class="mb-3" v-html="bannerTopo[0].itiResumo1"></h2>
            <p v-html="bannerTopo[0].itiResumo2" class="mb-4 textoEditor"></p>
          </div>
        </div>
        <!-- quadros -->
        <div v-for="quadros in listaSolucoes" :key="quadros.itiId" class="col-md-3 d-flex align-self-stretch">
          <div class="services">
            <div class="d-flex justify-content-end">
              <router-link :to="'/SolucaoTecnica/' + quadros.itiId + '/' + formataLink(quadros.itiNome)">
                <div class="icon d-flex"><span :class="quadros.itiCampoExtra4"></span></div>
              </router-link>
            </div>

            <div class="media-body">
              <router-link :to="'/SolucaoTecnica/' + quadros.itiId + '/' + formataLink(quadros.itiNome)">
              <h3 class="heading mb-3">{{ quadros.itiNome }}</h3>
              </router-link>
            </div>
            <router-link :to="'/SolucaoTecnica/' + quadros.itiId + '/' + formataLink(quadros.itiNome)" class="btn-custom d-flex align-items-center justify-content-center"><span class="fa fa-chevron-right"></span></router-link>
          </div>
        </div>

      </div>
    </div>

  </section>
  <!-- END soluções -->

  <PageCallAction></PageCallAction>

</template>

<script>
import PageCallAction from '@/components/PageCallAction.vue';
import { useHead } from '@vueuse/head'
import axios from 'axios';


export default {
  name: 'SolucoesView',
  components: {
    PageCallAction,
  },

  data: () => ({
    bannerTopo: [],
    solucoes: [],
    listaSolucoes: [],
    seoHome: [],

  }),

  methods: {
    formataLink(value) {
      return value.replaceAll('/', '').replaceAll(' ', '-').replaceAll('.', '').replaceAll('+', '');
    },

    carregaMetas(titulo, texto, palavrasChave) {
      useHead({
        title: titulo,
        meta: [
          { name: "description", content: texto },
          { name: "author", content: "Performance Elevadores" },
          { name: "keywords", content: palavrasChave }, 
          { httpEquiv: "Content-Language", content: "pt-BR" },
          { charset: "UTF-8" },
          { name: "robots", content: "index, follow" },
        ],
      })
    },
    textoLimpoSemHtml(value) {
      return value.replace(/<[^>]*>/g, '');
    },
  },

  created() {
  axios.get('/Process/InsInstitucional/institucional/53/seosolucoes/0/x')
      .then(response => {
        this.seoHome = response.data;
         let seoHome0 = this.seoHome[0];
         seoHome0.itiResumo1 = this.textoLimpoSemHtml(seoHome0.itiResumo1);
         seoHome0.itiResumo2 = this.textoLimpoSemHtml(seoHome0.itiResumo2);

         this.carregaMetas(seoHome0.itiNome, seoHome0.itiResumo1, seoHome0.itiResumo2);
        //console.log('topo seo')
        //console.log(this.seoHome)
      })
      .catch(error => {
        console.error(error);
      });


    //aqui busca banner topo
    axios.get('/Process/InsInstitucional/institucional/49/solucoestopo/0/x')
      .then(response => {
        this.bannerTopo = response.data;
        console.log('topo banner')
        console.log(this.bannerTopo)
      })
      .catch(error => {
        console.error(error);
      });
    //aqui busca lista soluções
    axios.get('/Process/InsInstitucional/institucional/44/listasolucoes/0/x')
      .then(response => {
        this.listaSolucoes = response.data;
        //console.log('principais soluções')
        //console.log(this.listaSolucoes)
      })
      .catch(error => {
        console.error(error);
      });

  },
}
</script>

<style scoped></style>